import React from "react";
import { useLang } from "../i18n/LangProvider";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-obsidian border-t border-edge py-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-5">
        <div className="flex items-baseline gap-3">
          <span className="font-serif text-2xl text-ivory">Grizzly</span>
          <span className="overline">· {t.footer.tagline}</span>
        </div>
        <p className="text-xs text-ivory/45 tracking-wider">
          © {year} {t.footer.crafted}. {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
